import moment, { Moment } from 'moment-timezone';
import { CoreSpace } from '@densityco/lib-api-types';

// Get the most recent "daily reset" timestamp, or midnight if the space has none
export function getLastDailyReset(space: CoreSpace, now?: Moment) {
  if (now === undefined) {
    now = moment.tz(space.time_zone);
  }

  // TODO: Fetch the last actual daily OR max-dwell reset with the `source` query string param(s)?
  const lastDailyReset = space.daily_reset
    ? moment.tz(space.daily_reset, 'HH:mm', space.time_zone)
    : moment.tz(space.time_zone).startOf('day');

  // If this reset happens after "now", back it up a day
  while (lastDailyReset.valueOf() > now.valueOf()) {
    lastDailyReset.subtract(1, 'day');
  }

  return lastDailyReset;
}
